import { createError, defineNuxtRouteMiddleware, useState } from '#imports'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

const MAX_REDIRECTIONS = 10

/**
 * Limits the number of redirections to prevent infinite loops and block the main thread on the server
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const logger = useLogger()
  const redirectionsCount = useState('redirections-count', () => 0)

  if (redirectionsCount.value >= MAX_REDIRECTIONS) {
    logger.error(
      `Reached maximum number of redirections (${MAX_REDIRECTIONS})`,
      {
        from: from.fullPath,
        to: to.fullPath,
      },
    )
    throw createError({
      statusCode: 500,
      statusMessage: 'Maximum number of redirections reached',
      fatal: true,
    })
  }

  redirectionsCount.value += 1

  return true
})
